import { render } from "./Fifth.vue?vue&type=template&id=2a51e219&scoped=true"
import script from "./Fifth.vue?vue&type=script&lang=js"
export * from "./Fifth.vue?vue&type=script&lang=js"

import "./Fifth.vue?vue&type=style&index=0&id=2a51e219&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\dragoncrew\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a51e219"]])

export default __exports__